import SecureLS from 'secure-ls'

const secureLs = new SecureLS()

const setupInterceptors = (apiInstance) => {
  apiInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      const isAuthRequest = (error.config?.url || '').includes('/api/1.0/auth')
      if (error.response && error.response.status === 401 && !isAuthRequest) {
        secureLs.removeAll()
        window.location.href = '/login'
      }
      return Promise.reject(error)
    },
  )
}

export default setupInterceptors
